export enum PostMessageId {
  'LEARN_MORE' = 'LEARN_MORE',
}
